import StackLineChart from './chart';
import StackLineSpec from './chartSpec';

export default StackLineChart;
export { StackLineSpec };
